import {
  GEOLOCATION_TIMEOUT_MS,
  GEOLOCATION_MAX_AGE_SHORT_MS,
  GEOLOCATION_HIGH_ACCURACY,
  GPS_ROAD_PROXIMITY_THRESHOLD_M,
  GPS_COORDINATE_CHANGE_THRESHOLD_M,
} from '../../../../../constants/geolocation';

export const WIZARD_CONSTANTS = {
  // Step transitions
  STEP_TRANSITION_DURATION: 300, // milliseconds

  // Search & Debounce
  ROAD_SEARCH_DEBOUNCE: 300, // milliseconds
  VALIDATION_DEBOUNCE: 500, // milliseconds

  // GPS Configuration (imported from centralized constants)
  GPS_TIMEOUT: GEOLOCATION_TIMEOUT_MS,
  GPS_MAX_AGE: GEOLOCATION_MAX_AGE_SHORT_MS,
  GPS_MAX_ROAD_DISTANCE_METERS: GPS_ROAD_PROXIMITY_THRESHOLD_M,
  GPS_ENABLE_HIGH_ACCURACY: GEOLOCATION_HIGH_ACCURACY,
  GPS_COORDINATE_THRESHOLD_METERS: GPS_COORDINATE_CHANGE_THRESHOLD_M,

  // Coordinate precision
  COORDINATE_PRECISION: 6, // decimal places for display
  CACHE_KEY_PRECISION: 4, // decimal places for cache keys (~11 meters granularity)

  // Validation - Step 1 (Basic Info)
  MIN_TITLE_LENGTH: 3,
  MAX_TITLE_LENGTH: 100,
  MIN_ASSIGNEE_LENGTH: 2,
  MAX_ASSIGNEE_LENGTH: 50,

  // Validation - Step 2 (Details)
  MIN_DESCRIPTION_LENGTH: 10,
  MAX_DESCRIPTION_LENGTH: 1000,

  // Validation - Step 3 (Requirements)
  MIN_REQUIREMENTS: 0,
  MAX_REQUIREMENTS: 20,

  // Search result limits
  MAX_ASSIGNEE_RESULTS: 10, // Maximum assignee suggestions

  // Cache expiry times
  GPS_DETECTION_CACHE_EXPIRY: 5 * 60 * 1000, // 5 minutes
  ASSIGNEE_CACHE_EXPIRY: 2 * 60 * 1000, // 2 minutes
} as const;
